<template>
    <div>
        <el-row>
        </el-row>
        <el-row>
            <el-col :span="24"  style="text-align: left;padding:20px 60px;">
                <span  class="mainContent">
                    <el-tabs tab-position="left" style="height: auto;" v-model="activemName" @tab-click="handlemTabClick">
                        <el-tab-pane v-for=" item in allType" :label="item.label" :name="item.value" :key="item.value">
                            <el-tabs type="border-card" >
                                <el-row  style="padding: 10px 0px 20px 20px;" v-if="activesName == item.value">
                                    <el-col :span="12" :offset="index > 0 ? 1 : 0">
                                        <el-card :body-style="{ padding: '0px' }">
                                        <img :src="activesPicName" style="width: 690px;height: 420px;"/>
                                        <div style="padding: 14px;display: flex;overflow-x:scroll;width: 660px;">
                                            <div class="bottom clearfix" style="margin-bottom: 15px;">
                                                <div v-for="(d, index) in productListJson" :key="index" v-show="activesName == d.allType" style="display: flex; float: left;">
                                                    <el-image
                                                    style="width: 100px; height: 100px; margin-right: 10px;"
                                                    :src="require('../../../../assets/images/productplus/'+d.allType +'_'+e+'.png')"
                                                    :fit="fit" v-for="e in d.picList" :key="e" @click="handleProPic( d.allType +'_' + e )" lazy/>
                                                </div>
                                            </div>
                                        </div>
                                        </el-card>
                                    </el-col>
                                </el-row>
                                <!-- <el-tab-pane v-for=" e in sType" :label="e.label" :name="e.value" :key="e.value" > -->
                                    <div v-show="activemName == item.value">
                                        <!-- <el-row v-for="item in tableData" :key="item.id">
                                            <el-col :span="8" style="padding: 10px 20px;">
                                                <div v-if="item.attchs.length !== 0" style="display: inline-flex; "><el-image v-for="( d, index ) in item.attchs" style="width: 350px; height: 200px; border:1px solid #ccc; margin-right:5px;" :src="this.tempPicUrl.filter(e=> e.id === item.attchs[index])[0]?.url"  :key="d" /></div>
                                                <div v-else >
                                                    <el-image style="width: 350px; height: 200px; border:1px solid #ccc; margin-right:5px;" :src="failPic"/>
                                                </div>
                                            </el-col>
                                            <el-col :span="16">
                                                <div class="productTitle"><b>{{item.productDetail_mtype}} - {{item.productDetail_stype}} - {{item.productDetail_name}}</b></div>
                                                <div>{{item.productDetail_Remark}} </div>
                                                <el-button type="primary" @click="detailProductRow( item )">查看</el-button>
                                            </el-col>
                                            <el-divider></el-divider>
                                        </el-row> -->
                                        <el-table v-loading="loading" ref="productList" :data="tableData" v-show="activemName !== '3_1' ? activemName !== '3_2' ? true : false : false " style="width: 100%;">
                                            <!-- <el-table-column fixed prop="id" label="产品ID" />
                                            <el-table-column prop="productDetail_mtype" label="大类名称" />
                                            <el-table-column prop="productDetail_stype" label="小类名称" /> -->
                                            <!-- <el-table-column prop="productDetail_name" label="产品名称" /> -->
                                            <el-table-column prop="attchs" :label="activemName === '99_1' ? '特色Special Service服务' : 'Technical parameters'" width="900">
                                                <template #default="scope" >
                                                    <div style="display: inline-flex; ">
                                                        <el-image v-for="(item,index ) in scope.row.attchs" style="width: 800px; border:1px solid #ccc; margin-right:5px;" :src="this.tempPicUrl.filter(e=> e.id === scope.row.attchs[index])[0]?.url"  :key="item" lazy/></div>
                                                </template>
                                            </el-table-column >
                                            <!-- <el-table-column fixed="right" label="操作">
                                                <template #default="scope">
                                                    <el-button link type="primary" size="small" @click.prevent="detailProductRow( scope.row )">查看</el-button>
                                                </template>
                                            </el-table-column> -->
                                        </el-table>
                                        <el-pagination
                                            v-show="activemName !== '3_1' ? activemName !== '3_2' ? true : false : false "
                                            small
                                            background
                                            layout="prev, pager, next"
                                            :total="this.totalRows"
                                            :page-count="this.totalPage"
                                            @current-change="hanldeCurrentPage"
                                            class="mt-4" style="margin: 7px 15px;">
                                        </el-pagination>
                                    </div>
                                <!-- </el-tab-pane> -->
                            </el-tabs>
                        </el-tab-pane>
                    </el-tabs>
                </span>
            </el-col>
        </el-row>
    </div>
    <detialProductDialog :isDetialProductShow="isDetialProductShow" :timekey="timerDetial" :currentProductDetial="currentRow" @hanldeCurrentPage="hanldeCurrentPage"></detialProductDialog>
</template>

<script>
import api from '@/api/api'
import cxf from '@/utils/GeneralFn';
import detialProductDialog from '@/components/manage/cx_main/component/child/detialProductDialog'
import img from '../../../../assets/images/product/product_failed.png';

    export default {
        name: "cn_products",
        components: {
            'detialProductDialog': detialProductDialog
        },
        data() {
            return {
                activemName:'1_1',
                activesName:'1_1',
                mType:cxf.getMainType_en(),
                sType:[],
                allType:[],
                tableData:[],
                totalRows:1,
                totalPage:1,
                productListParam : {
                    PageNo:1,
                    PageSize:10,
                    SortOrder:'desc',
                    SearchDate:"",
                    SearchBeginTime:"",
                    SearchEndTime:"",
                    ProductDetail_mtype:1,
                    ProductDetail_stype:1,
                    Lang:"en",
                    SearchParameters: []
                },
                tempPicUrl:[],
                isDetialProductShow:false,
                timerDetial:0,
                currentRow:[],
                loading:true,
                failPic:img,
                productListJson:[
                    {
                        allType : '1_1',
                        picList:[1,2,3]
                    },
                    {
                        allType : '1_2',
                        picList:[1,2,3,4]
                    },
                    {
                        allType : '1_3',
                        picList:[1,2,3]
                    },
                    {
                        allType : '1_4',
                        picList:[1,2]
                    },
                    {
                        allType : '2_1',
                        picList:[1,2,3]
                    },
                    {
                        allType : '2_2',
                        picList:[1,2,3,4]
                    },
                    {
                        allType : '3_1',
                        picList:[1,2]
                    },
                    {
                        allType : '3_2',
                        picList:[1,2,3]
                    },
                    {
                        allType : '4_1',
                        picList:[1,2,3,4]
                    },
                    {
                        allType : '4_2',
                        picList:[1,2,3,4]
                    },
                    {
                        allType : '4_3',
                        picList:[1,2,3]
                    },
                    {
                        allType : '4_4',
                        picList:[1,2,3,4]
                    },
                    {
                        allType : '5_1',
                        picList:[1,2,3,4]
                    },
                    {
                        allType : '5_2',
                        picList:[1,2,3,4]
                    },
                    {
                        allType : '99_1',
                        picList:[1,2,3]
                    }
                ],
                activesPicName:require("../../../../assets/images/productplus/1_1_1.png")
            }
        },
        created(){

        },
        mounted(){
            cxf.getAllType_en().forEach( e => {
                if ( e.children.length > 0 ) {
                    e.children.forEach( d => {
                        this.allType.push({
                        label:d.label,
                        value:e.value + '_' + d.value
                    })
                    })
                   
                }
            })
            this.handlemTabClick( {props:{name:"1_1"}} );
        },
        methods:{
            async getProductList() {
                this.loading = true;
                this.productListParam.SearchParameters = [];
                for ( let item in this.productListParam ) {
                    if ( item === "ProductDetail_mtype" && this.productListParam["ProductDetail_mtype"] !== "" && this.productListParam["ProductDetail_mtype"] !== 0 ) {
                        this.productListParam.SearchParameters.push({"Field":"ProductDetail_mtype","Op":"0","Value":this.productListParam["ProductDetail_mtype"]});
                    }
                    if ( item === "ProductDetail_stype" && this.productListParam["ProductDetail_stype"] !== "" && this.productListParam["ProductDetail_stype"] !== 0 ) {
                        this.productListParam.SearchParameters.push({"Field":"ProductDetail_sType","Op":"0","Value":this.productListParam["ProductDetail_stype"]});
                    }
                    if ( item === "Lang"  && this.productListParam["Lang"] !== "" ) {
                        this.productListParam.SearchParameters.push({"Field":"Lang","Op":"0","Value":this.productListParam["Lang"]});
                    }
                }

                console.log(this.productListParam.SearchParameters[0].Value);
                if ( typeof this.productListParam.SearchParameters[0].Value === 'undefined' ) {
                    this.productListParam.SearchParameters[0].Value = '99'
                }
                if ( typeof this.productListParam.SearchParameters[1].Value === 'undefined' ) {
                    this.productListParam.SearchParameters[1].Value = '99'
                }

                const _resList = await api.postProductListD( this.productListParam );
                if ( _resList.data.success ) {
                    const _tableList = _resList.data.data;
                    this.loading = false;
                    this.totalPage = _tableList.totalPage;
                   
                    this.totalRows = _tableList.totalRows;
                    this.tableData = _tableList.rows;
                    this.tableData.forEach( async e => {
                        let tempmTypeValue = e.productDetail_mtype;
                        let tempsTypeValue = e.productDetail_stype;
                        e.productDetail_mtype = cxf.getMainType_en( tempmTypeValue, true );
                        e.productDetail_stype = cxf.getSubType_en( tempmTypeValue, true, tempsTypeValue );
                        e.productDetail_status = cxf.getProductStatus_en( e.productDetail_status, true );
                        for ( let d in e.attchs) {
                           await this.getImage(e.attchs[d]);
                        }
                    })
                } else {
                    this.$message({
                        message: _resList.data.message,
                        type: 'warning'
                    });
                }
            },
            handlemTabClick( n ) {
                const altypeArr = n.props.name.split('_');
                this.productListParam.ProductDetail_mtype = altypeArr[0];
                this.productListParam.ProductDetail_stype = altypeArr[1];
                this.sType = altypeArr[1];
                this.activesName = n.props.name;
                this.activesPicName = require('../../../../assets/images/productplus/'
                + this.productListParam.ProductDetail_mtype 
                + '_'
                + this.productListParam.ProductDetail_stype +
                '_1.png');
                this.getProductList();
            },
            handlesTabClick( n ) {
                this.productListParam.ProductDetail_stype = n.props.name;
                this.getProductList();
            },
            detailProductRow ( row ) {
                this.isDetialProductShow = true;
                this.timerDetial = new Date().getTime();
                this.currentRow = row;
            },
            hanldeCurrentPage ( n ) {
                this.productListParam.ProductDetail_mtype = n.mType;
                this.productListParam.ProductDetail_stype = n.sType;
                this.getProductList();
            },
            async getImage( id ) {
                if (id) {
                    let _tempRes = await api.getSysFileInfoPreview({id: id});
                    if ( _tempRes.status === 200 ) {
                        return this.tempPicUrl.push({ id:id,url:window.URL.createObjectURL(new Blob([_tempRes.data]))})
                    } else {
                        return '--';
                    }
                } else {
                    return "无图片"
                }
                
            },
            handleProPic ( n ) {
                this.activesPicName = require('../../../../assets/images/productplus/'+n+'.png');
            }
        },
        watch:{
        }
    }
</script>

<style scoped>
.productTitle{
    font-size: 18px;
}
</style>